interface PreferredSourceApi {
  init(options: { theme: 'dark'; lang: 'en' }): unknown;
  addPreferredSource(): unknown;
}

interface PreferredSourceState {
  api: PreferredSourceApi | null;
  started: boolean;
  failed: boolean;
}

declare global {
  interface Window {
    PREFERRED_SOURCE?: { push(callback: (api: PreferredSourceApi) => void): unknown };
    __asePreferredSource?: PreferredSourceState;
  }
}

const scriptUrl = 'https://news.google.com/swg/js/v1/publisher.js';

function state(): PreferredSourceState {
  return window.__asePreferredSource ||= { api: null, started: false, failed: false };
}

function reportFailure(error: unknown) {
  const current = state();
  current.api = null;
  if (!current.failed) {
    console.warn('Preferred Source unavailable; the Google settings link remains available.', error);
  }
  current.failed = true;
}

export function loadPreferredSource(): void {
  if (typeof window === 'undefined') return;
  const current = state();
  if (current.started) return;
  current.started = true;

  const timeout = window.setTimeout(() => {
    reportFailure(new Error('Google Preferred Source initialization timed out.'));
  }, 15000);
  const queue = window.PREFERRED_SOURCE ||= [];
  queue.push((api) => {
    window.clearTimeout(timeout);
    if (current.failed || current.api) return;
    try {
      api.init({ theme: 'dark', lang: 'en' });
      current.api = api;
    } catch (error) {
      reportFailure(error);
    }
  });

  if (document.querySelector(`script[src="${scriptUrl}"]`)) return;
  const script = document.createElement('script');
  script.src = scriptUrl;
  script.async = true;
  script.setAttribute('preferred-sources-control', 'manual');
  script.addEventListener('error', () => {
    window.clearTimeout(timeout);
    reportFailure(new Error('Google Preferred Source script could not be loaded.'));
  }, { once: true });
  document.head.appendChild(script);
}

export function startPreferredSource(): boolean {
  if (typeof window === 'undefined') return false;
  const current = state();
  if (!current.api || current.failed) return false;
  try {
    const result = current.api.addPreferredSource();
    if (result instanceof Promise) {
      void result.catch(reportFailure);
    }
    return true;
  } catch (error) {
    reportFailure(error);
    return false;
  }
}
